var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngularLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2370,
    height: 2500,
    viewBox: "0 0 256 270",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.606.341L.849 44.95 20.88 211.022l106.86 58.732 107.412-59.528L255.175 44.16 127.606.341z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.532 53.758L127.31 14.466v241.256l96.561-53.441 18.66-148.523z",
    fill: "#A6120D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.073 54.466l17.165 148.525 95.07 52.731V14.462L15.074 54.465z",
    fill: "#DD1B16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M159.027 142.898L127.31 157.73H93.881l-15.714 39.305-29.228.54L127.31 23.227l31.717 119.672zm-3.066-7.467l-28.44-56.303-23.329 55.334h23.117l28.652.97z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.309 23.226l.21 55.902 26.47 55.377h-26.62l-.06 23.189 36.81.035 17.204 39.852 27.967.518-81.981-174.873z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularLogo);
export default __webpack_public_path__ + "static/media/angular-logo.e6ed573fa80c0dc1bf57730930ac0158.svg";
export { ForwardRef as ReactComponent };